(function () {
  "use strict";

  var root = document.querySelector("[data-product-selection-mobile]");
  if (!root) {
    return;
  }
  var assetBaseUrl = root.dataset.productSelectionAssetBase.replace(/\/$/, "");
  var selectorControls = root.querySelector("[data-mobile-selector-theme]");
  var platformButtons = Array.from(root.querySelectorAll("[data-mobile-platform]"));
  var typeButtons = Array.from(root.querySelectorAll("[data-mobile-type]"));
  var productGrid = root.querySelector("[data-mobile-product-grid]");
  var productEmpty = root.querySelector("[data-mobile-product-empty]");
  var productPagination = root.querySelector("[data-mobile-product-pagination]");
  var guideSearch = root.querySelector("[data-mobile-guide-search]");
  var guideCards = Array.from(root.querySelectorAll("[data-mobile-guide-card]"));
  var guideEmpty = root.querySelector("[data-mobile-guide-empty]");
  var guidePagination = root.querySelector("[data-mobile-guide-pagination]");
  var comparison = root.querySelector("[data-mobile-comparison]");
  var comparisonClose = root.querySelector("[data-mobile-comparison-close]");
  var products = Array.isArray(window.PRODUCT_SELECTION_PRODUCTS) ? window.PRODUCT_SELECTION_PRODUCTS : [];
  var activePlatform = "all";
  var activeType = "all";
  var currentProductPage = 0;
  var currentGuidePage = 0;
  var productsPerPage = 4;
  var guidesPerPage = 6;
  var productSwipeStart = null;
  var productPageTransitioning = false;
  var productPageTransitionTimer = null;

  function setActiveButton(buttons, activeButton) {
    buttons.forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateTypeButtons() {
    typeButtons.forEach(function (button) {
      var type = button.dataset.mobileType;
      var isActive = type === activeType;
      button.hidden = false;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function productMatchesPlatform(product) {
    var platforms = Array.isArray(product.platform) ? product.platform : [product.platform];
    if (activePlatform === "other") {
      return platforms.indexOf("other") !== -1;
    }
    if (activePlatform === "all" || platforms.indexOf("all") !== -1) {
      return true;
    }
    return platforms.indexOf(activePlatform) !== -1;
  }

  function productMatchesType(product) {
    var types = Array.isArray(product.type) ? product.type : [product.type];
    if (activeType === "all") {
      return true;
    }
    return types.indexOf(activeType) !== -1;
  }

  function getFilteredProducts() {
    return products.filter(function (product) {
      return productMatchesPlatform(product) && productMatchesType(product);
    });
  }

  function resolveProductImage(imageUrl) {
    if (!imageUrl) {
      return "";
    }
    if (/^(?:https?:)?\/\//i.test(imageUrl) || imageUrl.charAt(0) === "/") {
      return imageUrl;
    }
    return assetBaseUrl ? assetBaseUrl + "/" + imageUrl.replace(/^\/+/, "") : imageUrl;
  }

  function createProductCard(product) {
    var card = document.createElement("article");
    var media = document.createElement("div");
    var image = document.createElement("img");
    var title = document.createElement("h3");
    var actions = document.createElement("div");
    var compareButton = document.createElement("button");
    var purchaseLink = document.createElement("a");

    card.className = "mobile-product-card";
    media.className = "mobile-product-card__media";
    actions.className = "mobile-product-card__actions";
    image.src = resolveProductImage(product.image);
    image.alt = product.name || "Robot product";
    image.width = 800;
    image.height = 800;
    image.loading = "lazy";
    title.textContent = product.name || "Unnamed product";
    compareButton.type = "button";
    compareButton.textContent = "Compare";
    compareButton.setAttribute("data-mobile-compare", "");
    compareButton.setAttribute("aria-haspopup", "dialog");
    purchaseLink.href = window.getProductSelectionProductUrl
      ? window.getProductSelectionProductUrl(product)
      : "/products/" + String(product.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    purchaseLink.textContent = "View Details";
    if (purchaseLink.getAttribute("href") !== "#") {
      purchaseLink.target = "_blank";
      purchaseLink.rel = "noopener noreferrer";
    }

    media.appendChild(image);
    actions.appendChild(compareButton);
    actions.appendChild(purchaseLink);
    card.appendChild(media);
    card.appendChild(title);
    card.appendChild(actions);
    return card;
  }

  function createPaginationButton(className, label, disabled, onClick) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className;
    button.setAttribute("aria-label", label);
    button.disabled = disabled;
    button.addEventListener("click", onClick);
    return button;
  }

  function renderPagination(container, pageCount, currentPage, onPageChange) {
    var firstPage;
    var lastPage;
    var pageIndex;

    if (!container) {
      return;
    }
    container.replaceChildren();
    container.hidden = pageCount <= 1;
    if (pageCount <= 1) {
      return;
    }

    container.appendChild(createPaginationButton(
      "is-arrow is-prev",
      "Previous page",
      currentPage === 0,
      function () { onPageChange(currentPage - 1); }
    ));

    firstPage = Math.max(0, Math.min(currentPage - 2, pageCount - 5));
    lastPage = Math.min(pageCount, firstPage + 5);
    for (pageIndex = firstPage; pageIndex < lastPage; pageIndex += 1) {
      (function (targetPage) {
        var dot = createPaginationButton(
          targetPage === currentPage ? "is-active" : "",
          "Page " + (targetPage + 1),
          false,
          function () { onPageChange(targetPage); }
        );
        dot.setAttribute("aria-current", targetPage === currentPage ? "page" : "false");
        container.appendChild(dot);
      }(pageIndex));
    }

    container.appendChild(createPaginationButton(
      "is-arrow is-next",
      "Next page",
      currentPage >= pageCount - 1,
      function () { onPageChange(currentPage + 1); }
    ));
  }

  function updateProducts() {
    var filteredProducts = getFilteredProducts();
    var pageCount = Math.ceil(filteredProducts.length / productsPerPage);
    var pageStart;
    var fragment;

    if (currentProductPage >= pageCount) {
      currentProductPage = Math.max(0, pageCount - 1);
    }
    pageStart = currentProductPage * productsPerPage;
    fragment = document.createDocumentFragment();
    filteredProducts.slice(pageStart, pageStart + productsPerPage).forEach(function (product) {
      fragment.appendChild(createProductCard(product));
    });
    if (productGrid) {
      productGrid.replaceChildren(fragment);
    }
    if (productEmpty) {
      productEmpty.hidden = filteredProducts.length !== 0;
    }
    renderPagination(productPagination, pageCount, currentProductPage, function (targetPage) {
      changeProductPage(targetPage);
    });
  }

  function clearProductPageTransition() {
    if (productPageTransitionTimer) {
      window.clearTimeout(productPageTransitionTimer);
      productPageTransitionTimer = null;
    }
    if (productGrid) {
      productGrid.classList.remove(
        "is-page-entering-next",
        "is-page-entering-prev",
        "is-page-leaving-next",
        "is-page-leaving-prev"
      );
    }
    productPageTransitioning = false;
  }

  function changeProductPage(targetPage) {
    var pageCount = Math.ceil(getFilteredProducts().length / productsPerPage);
    var direction;

    if (productPageTransitioning || targetPage < 0 || targetPage >= pageCount || targetPage === currentProductPage) {
      return;
    }
    if (!productGrid || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
      currentProductPage = targetPage;
      updateProducts();
      return;
    }

    direction = targetPage > currentProductPage ? "next" : "prev";
    productPageTransitioning = true;
    productGrid.classList.add("is-page-leaving-" + direction);
    productPageTransitionTimer = window.setTimeout(function () {
      productGrid.classList.remove("is-page-leaving-" + direction);
      currentProductPage = targetPage;
      updateProducts();
      productGrid.classList.add("is-page-entering-" + direction);
      productPageTransitionTimer = window.setTimeout(clearProductPageTransition, 240);
    }, 180);
  }

  function startProductSwipe(event) {
    var touch;

    if (event.touches.length !== 1) {
      productSwipeStart = null;
      return;
    }
    touch = event.touches[0];
    productSwipeStart = {
      x: touch.clientX,
      y: touch.clientY
    };
  }

  function endProductSwipe(event) {
    var touch;
    var deltaX;
    var deltaY;
    var pageCount;
    var targetPage;

    if (!productSwipeStart || event.changedTouches.length !== 1) {
      productSwipeStart = null;
      return;
    }
    touch = event.changedTouches[0];
    deltaX = touch.clientX - productSwipeStart.x;
    deltaY = touch.clientY - productSwipeStart.y;
    productSwipeStart = null;

    if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) {
      return;
    }

    pageCount = Math.ceil(getFilteredProducts().length / productsPerPage);
    targetPage = deltaX < 0 ? currentProductPage + 1 : currentProductPage - 1;
    if (targetPage < 0 || targetPage >= pageCount) {
      return;
    }
    changeProductPage(targetPage);
  }

  function normalizeGuideSearch(value) {
    return value.normalize("NFKC").toLowerCase().replace(/[^a-z0-9\u3400-\u9fff\s]/g, "").replace(/\s+/g, " ").trim();
  }

  function getFilteredGuides() {
    var query = guideSearch ? guideSearch.value : "";
    var keywords = query.split(/[\s,，、;；]+/).map(normalizeGuideSearch).filter(Boolean);
    return guideCards.filter(function (card) {
      var image = card.querySelector("img");
      var title = card.querySelector("h3");
      var searchableText = normalizeGuideSearch([
        card.dataset.search || "",
        card.dataset.tags || "",
        title ? title.textContent : "",
        image ? image.alt : ""
      ].join(" "));
      var searchWords = searchableText.split(" ");
      return keywords.every(function (keyword) {
        return searchableText.indexOf(keyword) !== -1 || searchWords.some(function (word, index) {
          return word + (searchWords[index + 1] || "") === keyword;
        });
      });
    });
  }

  function updateGuides() {
    var filteredGuides = getFilteredGuides();
    var pageCount = Math.ceil(filteredGuides.length / guidesPerPage);
    var pageStart;
    var visibleGuides;

    if (currentGuidePage >= pageCount) {
      currentGuidePage = Math.max(0, pageCount - 1);
    }
    pageStart = currentGuidePage * guidesPerPage;
    visibleGuides = filteredGuides.slice(pageStart, pageStart + guidesPerPage);
    guideCards.forEach(function (card) {
      card.hidden = visibleGuides.indexOf(card) === -1;
    });
    if (guideEmpty) {
      guideEmpty.hidden = filteredGuides.length !== 0;
    }
    renderPagination(guidePagination, pageCount, currentGuidePage, function (targetPage) {
      currentGuidePage = targetPage;
      updateGuides();
    });
  }

  function openComparison() {
    if (!comparison) {
      return;
    }
    comparison.hidden = false;
    document.body.classList.add("is-modal-open");
    if (comparisonClose) {
      comparisonClose.focus();
    }
  }

  function closeComparison() {
    if (!comparison) {
      return;
    }
    comparison.hidden = true;
    document.body.classList.remove("is-modal-open");
  }

  platformButtons.forEach(function (button) {
    button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false");
    button.addEventListener("click", function () {
      clearProductPageTransition();
      activePlatform = button.dataset.mobilePlatform;
      currentProductPage = 0;
      setActiveButton(platformButtons, button);
      if (selectorControls) {
        selectorControls.dataset.mobileSelectorTheme = activePlatform;
      }
      updateProducts();
    });
  });

  typeButtons.forEach(function (button) {
    button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false");
    button.addEventListener("click", function () {
      clearProductPageTransition();
      activeType = button.dataset.mobileType;
      currentProductPage = 0;
      setActiveButton(typeButtons, button);
      updateProducts();
    });
  });

  if (productGrid) {
    productGrid.addEventListener("touchstart", startProductSwipe, { passive: true });
    productGrid.addEventListener("touchend", endProductSwipe, { passive: true });
    productGrid.addEventListener("touchcancel", function () {
      productSwipeStart = null;
    }, { passive: true });
    productGrid.addEventListener("click", function (event) {
      if (event.target.closest("[data-mobile-compare]")) {
        openComparison();
      }
    });
  }

  root.addEventListener("click", function (event) {
    if (event.target.closest('a[href="#"]')) {
      event.preventDefault();
    }
  });

  if (guideSearch) {
    guideSearch.addEventListener("input", function () {
      currentGuidePage = 0;
      updateGuides();
    });
  }

  if (comparisonClose) {
    comparisonClose.addEventListener("click", closeComparison);
  }

  if (comparison) {
    comparison.addEventListener("click", function (event) {
      if (!event.target.closest(".mobile-comparison__dialog")) {
        closeComparison();
      }
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && comparison && !comparison.hidden) {
      closeComparison();
    }
  });

  updateTypeButtons();
  updateProducts();
  updateGuides();
}());
